<template>
  <div class="main">
  <div class="uploadFileBox" v-if="showUpload">
    <div class="uploadCon">
      <img src="../../assets/image/icon/icon_cancel.png" style="position: absolute;width: 0.3rem;right: 0.2rem;cursor: pointer" @click="changeShowUpload(false)">
      <div class="title">上传简历</div>
      <div class="titleSecond">上传简历后我们会立即联系你</div>
      <div class="jobTitle">{{jobName}}</div>
      <div  @click="triggerUpload" class="uploadBtn">立即上传(仅支持word和pdf)</div>
      <input
        type="file"
        ref="fileInput"
        accept=".doc,.docx,.pdf"
        style="display: none"
        @change="handleFileUpload"
      />
      <div class="otherWay">还可将简历发送至 <span style="color: black">hr@magicwifi.com.cn</span></div>
    </div>
  </div>
    <div class="banner">
      <div class="titleSub">Talent recruitment</div>
      <div class="title wow animate__animated durationTime animate__fadeInUp">人才招聘</div>
      <div class="desc wow animate__animated durationTime animate__fadeInUp">携手志同道合的伙伴，期待您的加入！</div>
    </div>
    <div class="coll">
      <div>
        <div class="titleSub">Resume Submission</div>
        <div class="title wow animate__animated durationTime animate__fadeInUp">投递渠道</div>
        <div class="contact wow animate__animated durationTime animate__fadeInUp">
          <img class="pic" src="../../assets/image/about/tel.png">
          <div  class="desc1">服务热线：</div>
          <div class="tel">13049890215</div>
        </div>
        <div class="contact wow animate__animated durationTime animate__fadeInUp">
          <img style="width: 0.1662rem;height: 0.1246rem" class="pic" src="../../assets/image/about/email.png">
          <div  class="desc1">电子邮箱：</div>
          <div class="tel">hr@magicwifi.com.cn</div>
        </div>
        <div class="contact wow animate__animated durationTime animate__fadeInUp">
          <img style="width: 0.1455rem;height: 0.1819rem"  class="pic" src="../../assets/image/about/address.png">
          <div class="desc1">联系地址：</div>
          <div class="tel">深圳市南山区科技园南长虹科技大厦2105</div>
        </div>
      </div>
      <div class="wx-public wow animate__animated durationTime animate__fadeInUp">
        <img v-if="imgFlag==0" class="wx-public-img" src="@/assets/image/index/wx-public.jpg">
        <img v-else class="wx-public-img" :src="img">
<!--        <div id="wl-qrcode2"></div>-->
        <div class="wx-public-text">扫码联系我们</div>
      </div>
    </div>
    <div class="recruitment">
      <div
        :class="[activeId==item.id?'itemActive':'','item', 'wow', 'animate__animated', 'durationTime', 'animate__fadeInUp']"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <img class="upOrDown" @click="itemActive(item.id)" :src="activeId == item.id ? require('@/assets/image/icon/icon_up.png') : require('@/assets/image/icon/icon_down.png')">
        <div class="job">{{item.title}}</div>
        <div class="info">
          <div class="con">{{item.type}}</div>
          <div class="con">{{item.experience}}</div>
          <div class="con">{{item.address}}</div>
        </div>
        <div @click="itemActive(item.id)"  style="cursor: pointer" class="jobSimpleDesc" v-if="activeId==0 || activeId!=item.id">
          <div class="req" v-for="(con,i) in item.work.slice(0, 2)" :key="'work' + i">
            {{i+1}}、{{con}}
          </div>
          <div class="req">...</div>
        </div>
        <div class="jobDetail" :key="`detail`+index" v-if="activeId==item.id">
          <div style="margin-top: 0.4rem;line-height: 0.23rem;">
            <div style="font-size: 0.14rem;font-weight: bold">岗位职责</div>
            <div class="req" v-for="(con,i) in item.work" :key="'work' + i">
              {{i+1}}、{{con}}
            </div>
          </div>
          <div style="margin-top: 0.2rem;line-height: 0.23rem;">
            <div style="font-size: 0.14rem;font-weight: bold">岗位要求</div>
            <div class="req" v-for="(con,i) in item.requirement" :key="'req' + i">
              {{i+1}}、{{con}}
            </div>
          </div>
          <div class="upload" @click="uploadJob(item.title)">申请职位</div>
        </div>


      </div>
    </div>
    <div class="paging">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size.sync="pageSize"
        :current-page.sync="currentPage"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import requirementData from "./recruitment";
import axios from "axios";
import {uploadFile} from '../../util/api'
export default {
  name: "contact",
  data() {
    return {
      dataList:[],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      imgFlag:0,
      img:'',
      activeId:0,
      jobName:'测试职位',
      showUpload:false,
    };
  },
  created() {
    this.getList();
    this.initializeAndRun();
  },
  computed: {},
  mounted() {
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  },
  methods: {
    getList() {
      let datas = [...requirementData];
      const datasCopy = [...datas];
      this.dataList = datasCopy.splice(
        (this.currentPage - 1) * this.pageSize,
        this.pageSize
      );
      this.total = datas.length;
    },
    handleCurrentChange(page){
      this.currentPage=page;
      this.getList();
    },
    loadScript(src, id) {
      return new Promise((resolve, reject) => {
        if (document.getElementById(id)) {
          resolve(); // 如果脚本已经存在，直接resolve
          return;
        }

        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.id = id;

        script.onload = () => {
          resolve(); // 脚本加载成功，resolve
        };

        script.onerror = () => {
          reject(new Error(`Script load error for ${src}`)); // 脚本加载失败，reject
        };

        let s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
      });
    },
    async initializeAndRun() {
      try {
        await this.loadScript(
          'https://material.weiling.cn/h5/willing-third-party-js/v1/qrcode-custom-comp-v1.min.js',
          'wlQRCS'
        );

        // 等待脚本加载完成后初始化
        wlQrcodeCustomComp.init({
          wl_id: 'wpW2WmDAAAsuSkpyHYrwjV4tnMu-Zjag', // [修改1：将wl_id粘贴至此]
        });

        // 初始化完成后要执行的代码
        console.log('wlQrcodeCustomComp initialized');
        // 在这里添加你需要执行的代码
        this.getCode();
      } catch (error) {
        console.error(error); // 处理加载脚本时的错误
      }
    },
    getCode(){
      wlQrcodeCustomComp.getQrCodeUrl(
        {
          wl_qrcode_id: "1801157726622015488", //  [修改1：将wl_qrcode_id粘贴至此]
        },
        (data) => {
          console.log(data); // data中包含二维码图片地址
          if(data.code==200){
            this.imgFlag=1;
            this.img=data.data.qr_code;
          }
        }
      );
    },
    itemActive(id){
      if(id==this.activeId){
        this.activeId=0;
      }else {
        this.activeId=id;
      }
    },
    uploadJob(title){
      this.jobName=title;
      this.changeShowUpload(true)
    },
    // 处理文件上传
    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {

        return;
      }

      // 获取文件大小（单位：字节）
      const fileSize = file.size;
      const maxSize = 2 * 1024 * 1024; // 2MB

      // 获取文件后缀
      const fileSuffix = file.name.split(".").pop().toLowerCase();

      // 检查文件大小
      if (fileSize > maxSize) {
        this.$message.error('文件大小超出限制，请上传小于2MB的文件！');
        return;
      }

      // 检查文件类型
      if (!["doc", "docx", "pdf"].includes(fileSuffix)) {
        alert("");
        this.$message.error('不支持的文件类型，仅允许上传 Word (.doc, .docx) 和 PDF (.pdf) 文件！');
        return;
      }
      // 创建 FormData 并上传文件
      const formData = new FormData();
      formData.append("file", file);
      let loading;
      try {
          loading = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        const response = await axios.post(uploadFile+"?jobName="+this.jobName, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        if(response.data.code===0){
          this.$message.success("简历投递成功~");
          this.changeShowUpload(false);
        }else {
          this.$message.error("文件上传失败:" +response.data.message);
        }

      } catch (error) {
        console.log(error)
        if (error.response && error.response.data) {
          this.$message.error("文件上传失败,请稍后再试" );
        } else {
          this.$message.error("文件上传失败，请稍后再试！");
        }
      }finally {
        // 重置文件输入框
        this.$refs.fileInput.value = null;
        loading.close();
      }

      // 这里可以继续实现将文件上传到服务器的逻辑
    },
    // 触发文件选择器
    triggerUpload() {
      this.$refs.fileInput.click();
    },
    changeShowUpload(b){
      this.showUpload=b;
    }
  }
}
</script>

<style scoped lang="scss">
.uploadFileBox{
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.5); /* 黑色背景，透明度为 0.2 */
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.18rem;
  .uploadCon{
    position: relative;
    width: 5.3rem;
    opacity: 1;
    background-image: -webkit-linear-gradient(-73deg, rgb(250, 250, 250) 0%, rgb(255, 255, 255) 100%);
    padding: 0.3rem 0.2rem;
    border-radius: 0.1rem;
    .title{
      font-size: 0.2rem;
      color: black;
      font-weight: bold;
    }
    .titleSecond{
      font-size: 0.15rem;
      color: #778091;
    }
    .jobTitle{
      box-shadow: inset 0px 0.06rem 0.04rem 0px rgba(148, 148, 149, 0.08);
      border-radius: 0.05rem;
      border: 0.01rem solid #e6e6f1;
      padding-left: 0.16rem;
      height: 0.45rem;
      display: flex;
      align-items: center;
      margin-top: 0.15rem;
      font-size: 0.14rem;
    }
    .uploadBtn{
      background: #fef100;
      border-radius: 0.05rem;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.1rem;
      color: black;
      margin-top: 0.3rem;
      font-size: 0.14rem;
      font-weight: 500;
      cursor: pointer;
    }
    .otherWay{
      font-size: 0.15rem;
      color: #778091;
      margin-top: 0.08rem;
    }
  }
}
.banner {
  width: 100%;
  height: 5.8rem;
  background: url('../../assets/image/about/talent-bg.png') center no-repeat;
  background-size: cover;
  padding-left: 2.18rem;
  .title {
    font-size: 0.44rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    margin-top: 2.75rem;
    position: relative;
    color: #fff;
    display: inline-block;
  }
  .titleSub {
    content: "NEWS";
    position: absolute;
    margin-top: 2.44rem;
    font-size: 0.44rem;
    font-weight: 500;
    color: rgb(169 160 160 / 51%);
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }
  .desc{
    font-weight: 400;
    font-size: 0.24rem;
    color: #FFFFFF;
    margin-top: 0.2rem;
  }
}
.coll {
  width: 100%;
  background: url('../../assets/image/about/coll-bg.png') center no-repeat;
  background-size: cover;
  padding:1rem 2.18rem 1.4rem 2.18rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    font-size: 0.34rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    margin-top: 0.24rem;
    position: relative;
    color: #333333;
    display: inline-block;
    margin-bottom: 0.55rem;
  }
  .titleSub {
    position: absolute;
    font-size: 0.34rem;
    font-weight: 500;
    //color: rgba(255, 255, 255, 0.51);
    color: #c8c8c8;
    text-shadow: 0px 0.03rem 0.06rem rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }
  .contact{
    display: flex;
    margin-bottom: 0.43rem;
    align-items: center;
    .pic{
      width: 0.17rem;
      height: 0.17rem;
      margin-right: 0.1rem;
    }
    .desc1{
      font-size: 0.16rem;
      font-weight: 400;
      color: #333333;
    }
    .tel{
      color: #333333;
      font-weight: bold;
      font-size: 20px;
      font-family: DIN Alternate, DIN Alternate;
    }
  }
  .wx-public{
    display: flex;
    flex-direction: column;
    align-items: center;
    .wx-public-img{
      width: 1.66rem;
      height: 1.66rem;
    }
    .wx-public-text{
      margin-top: 0.2rem;
      font-weight: 400;
      font-size: 0.16rem;
      color: #333333;
    }
  }

}
.recruitment{


  padding: 1rem 2.18rem 1.4rem 2.18rem;
  .itemActive{
    border: none !important;
    background-color: rgb(241, 243, 248) !important;
  }
  .item{
    transition: flex 0.5s ease;
    padding: 0.4rem 2rem 0.4rem 0.8rem;
    border: 0.015rem  solid rgb(232, 232, 232);
    //background: #F3F3F3;
    //box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
    margin-bottom: 0.2rem;
    position: relative;

    .upOrDown{
      width: 0.5rem;
      position: absolute;
      top:0.5rem;
      right: 0.5rem;
      cursor: pointer;
    }
    .job{
      font-weight: bold;
      font-size: 0.24rem;
      color: #333333;
    }
    .info{
      margin-top: 0.2rem;
      display: flex;
      .con{
        font-weight: 500;
        font-size: 0.17rem;
        color: #333333;
        border-right: 0.01rem #9c9393 solid;
        padding: 0 0.1rem;

      }
      .con:last-child{
        border: 0;
      }
      .con:first-child{
        padding-left: 0;
      }
    }
    .req{
      font-weight: 400;
      font-size: 0.16rem;
      color: #333333;
      margin-top: 0.1rem;
      line-height: 0.26rem;
    }
  }
  .item:last-child{
    margin-bottom: 0;
  }
}
</style>
<style scoped>
.paging {
.el-pagination {
  padding: 0;
  color: #333 !important;
  display: flex;
  justify-content: center;
  background: #fef100;
}
.el-pagination button {
  margin: 0 !important;
  height: 0.8rem !important;
  line-height: 0.8rem !important;
  min-width: 0.8rem !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #fdfce3 !important;
  color: #333;
}
.el-pager li {
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  font-size: 0.16rem;
  height: 0.8rem !important;
  line-height: 0.8rem !important;
  width: 0.72rem;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background-color: transparent;
  color: #333 !important;
  transition: all 0.3s ease-in-out;
&:hover {
   background-color: rgba(253, 252, 227, 0.8) !important;
 }
}
.el-pagination .btn-next .el-icon,
.el-pagination .btn-prev .el-icon {
  font-size: 0.14rem;
  color: #333;
  font-weight: 400;
}
.el-icon-arrow-left:before {
  content: "上一页";
}
.el-icon-arrow-right:before {
  content: "下一页";
}
}
.upload{
  background: url('../../assets/image/wireless/more-icon.png') center no-repeat;
  background-size: cover;
  width: 1.4rem;
  height: 0.42rem;
  font-weight: 400;
  font-size: 0.16rem;
  color: #333333;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.2rem;
  cursor: pointer;
}
.upload:hover{
  opacity: 0.8;
}
.mian{
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/about/contact.vue